import { render, staticRenderFns } from "./ShippingAddressSelect.vue?vue&type=template&id=3e22ee1b&"
import script from "./ShippingAddressSelect.vue?vue&type=script&lang=js&"
export * from "./ShippingAddressSelect.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/Users/fhartwig/Sites/Plenty Update/DIA-3dprima_v2/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('3e22ee1b')) {
      api.createRecord('3e22ee1b', component.options)
    } else {
      api.reload('3e22ee1b', component.options)
    }
    module.hot.accept("./ShippingAddressSelect.vue?vue&type=template&id=3e22ee1b&", function () {
      api.rerender('3e22ee1b', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "resources/js/src/app/components/customer/addressSelectCheckoutCustom/ShippingAddressSelect.vue"
export default component.exports